import { EntryDocument } from "@/types/entry.ts";
import { DEFAULT_DATE_FORMAT } from "@/util/constants.ts";
import { normalizeApostrophes } from "@/util/stringUtils.ts";
import {
  transformMedia,
  expandMediaCollection,
} from "@/util/mediaHelper.v2.ts";

export default function mapDocToEntry(
  entryDoc: EntryDocument,
  isTouchScreen: boolean,
  dateFormat?: string
) {
  return {
    firstName: entryDoc.firstName,
    lastName: entryDoc.lastName,
    activity: {
      content: normalizeApostrophes(entryDoc.activity),
      options: {
        disableExternalLinks: isTouchScreen,
      },
    },
    eventDate: entryDoc.eventDate,
    graduationDate: entryDoc.graduationDate,
    type: {
      content: normalizeApostrophes(entryDoc.type),
      options: {
        disableExternalLinks: isTouchScreen,
      },
    },
    cardBackground: entryDoc.cardBackground.map(transformMedia),
    headshot: entryDoc.headshot.map(transformMedia),
    background: entryDoc.background.map(transformMedia),
    media: expandMediaCollection(entryDoc.media.map(transformMedia)),
    layout: entryDoc.layout,
    useSlideshowForPdf: entryDoc.useSlideshowForPdf,
    showSlideshowAsGallery: entryDoc.showSlideshowAsGallery,
    description: {
      content: entryDoc.description,
      options: {
        disableExternalLinks: isTouchScreen,
      },
    },
    dateFormat: dateFormat ?? DEFAULT_DATE_FORMAT,
    iframeSheetName: entryDoc.iframeSheetName,
    iframeLayoutURL: entryDoc.iframeLayoutURL,
    tableOfContents: entryDoc.tableOfContents,
    _id: entryDoc._id,
    isLive: entryDoc.isLive,
    imageObjectFit: entryDoc.imageObjectFit,
    path: entryDoc.path,
    recordInfo: entryDoc.recordInfo,
    categoryID: entryDoc.categoryID,
    index: entryDoc.index,
  };
}
